//------------------------------------------------------ externos
import { useState } from "react";
//------------------------------------------------------ elementos
import TextButton from "../buttons/TextButton";
//------------------------------------------------------ funciones
import { faltaEnBorrador } from "../../shared/stockDesdeTablero";

/* Crear un artículo de Stock sin salir del movimiento (Nico, 20/10).
 *
 * Aparece debajo del buscador cuando se elige algo que Stock no tiene: una
 * herramienta del tablero, o lo escrito tal cual. Va precargado —desde el
 * tablero, con su nombre y el tipo que le corresponde— así que lo normal es
 * un solo click en «Crear y elegir». Los datos quedan a la vista antes de
 * crear porque el artículo nace para siempre en el padrón de todos los
 * depósitos: un tipo equivocado cambia el código.
 *
 * NO ESCRIBE NADA HASTA EL BOTÓN, y «Cancelar» lo cierra sin rastro.
 */
const CrearArticulo = ({
  borrador,
  setBorrador,
  tipos = [],
  unidades = [],
  panolNombre = "",
  sinTablero = false,
  onCrear,
  onCancelar,
}) => {
  const [creando, setCreando] = useState(false);
  const [error, setError] = useState("");
  const h = borrador.herramienta;

  const cambiar = (campo) => (e) =>
    setBorrador({ ...borrador, [campo]: e.target.value });

  const crear = async () => {
    const falta = faltaEnBorrador(borrador, tipos);
    if (falta) {
      setError(falta);
      return;
    }
    setCreando(true);
    setError("");
    const r = await onCrear(borrador);
    setCreando(false);
    if (!r?.ok) setError(r?.error || "No se pudo crear el artículo.");
  };

  return (
    <div className="crear-articulo" role="group" aria-label="Crear el artículo en Stock">
      <strong className="crear-articulo-titulo">
        {h ? "Crear en Stock lo que ya está en el tablero" : "Crear un artículo nuevo en Stock"}
      </strong>
      <p className="crear-articulo-texto">
        {h ? (
          <>
            «{h.nombre}» está en el tablero de herramientas
            {panolNombre ? ` (${panolNombre})` : ""} pero todavía no en Stock,
            por eso no aparecía. Se crea con estos datos y ya lo podés cargar.
          </>
        ) : (
          /* Dice lo que sabe: que con ESE nombre no lo encontró. «No existe»
             sería afirmar más de lo que se buscó (revisión del 20/10: con
             «guantes de tela» la pantalla decía que Guante Tela no estaba en
             el tablero, y estaba). */
          <>
            {sinTablero
              ? "No lo encontré con ese nombre en Stock, y el tablero de herramientas no se pudo leer."
              : "No lo encontré con ese nombre ni en Stock ni en el tablero de herramientas."}{" "}
            Si es nuevo, se crea acá con estos datos y ya lo podés cargar.
          </>
        )}
      </p>
      <label className="crear-articulo-campo">
        <span>Qué es</span>
        <input
          className="form-input"
          value={borrador.descripcion}
          onChange={cambiar("descripcion")}
          aria-label="Qué es"
        />
      </label>
      <div className="crear-articulo-fila">
        <label className="crear-articulo-campo">
          <span>Tipo</span>
          <select
            className="form-input"
            value={borrador.tipo}
            onChange={cambiar("tipo")}
            aria-label="Tipo"
          >
            {tipos.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
        </label>
        <label className="crear-articulo-campo">
          <span>Unidad</span>
          <select
            className="form-input"
            value={borrador.unidad}
            onChange={cambiar("unidad")}
            aria-label="Unidad"
          >
            {unidades.map((u) => (
              <option key={u} value={u}>{u}</option>
            ))}
          </select>
        </label>
      </div>
      <p className="crear-articulo-nota">
        El código sale solo, con las letras del tipo. El proveedor queda como
        genérico: si hace falta, se cambia después desde el padrón de Stock.
      </p>
      {error && (
        <p className="crear-articulo-error" role="alert">{error}</p>
      )}
      <div className="crear-articulo-botones">
        <TextButton
          text={creando ? "Creando…" : "Crear y elegir"}
          mini={true}
          type="button"
          onClick={creando ? undefined : crear}
        />
        <button type="button" className="crear-articulo-cancelar" onClick={onCancelar}>
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default CrearArticulo;
